<template>
  <div id="swiper" @mouseover="stopAuto" @mouseout="autoPlay">
    <div class="swiper-box"
      :style="{width:allCount,'-webkit-transition':transitionConfig,'-webkit-transform':slateX}"
      ref="swiper" >
      <carousel-item :img="imgList[imgList.length-1].img" :imgWidth="-imgWidth" v-if="loop" />
      <carousel-item
        v-for="(item,index)  in imgList"
        :key="index"
        :img="item.img"
        :imgWidth="imgWidth*index"
      ></carousel-item>
      <carousel-item :img="imgList[0].img" :imgWidth="imgWidth*imgList.length" v-if="loop"></carousel-item>
    </div>
    <div class="swiper-dots" v-if="dots">
      <button
        v-for="(item,index) in imgList.length"
        :key="index"
        :class="{active:index==dotsIndex}"
        @click="toDots(index)"
      >{{item}}</button>
    </div>
  </div>
</template>
<script>
import CarouselItem from "./carouselItem";
export default {
  name: "swiper",
  props: {
    // 图片宽
    imgWidth: {
      type: Number,
      default: 100
    },
    // 图片地址
    imgList: {
      type: Array
    },
    // 指示器
    dots: {
      type: Boolean,
      default: true
    },
    arrow: {
      type: Boolean,
      default: true
    },
    // 初始播放位置
    initIndex: {
      type: Number,
      default: 0
    },
    // 是否循环
    loop: {
      type: Boolean,
      default: true
    },
    // 持续时间
    duration: {
      type: Number,
      default: 0.3
    },
    // 自动播放
    auto: {
      type: Boolean,
      default: false
    },
    // 自动播放时间间隔
    autoTime: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      imgIndex: 0,
      durationTime: 0.2,
      dotsIndex: 0,
      autoer: null
    };
  },
  components: {
    CarouselItem: CarouselItem
  },
  computed: {
    allCount() {
      return this.imgList.length * this.imgWidth + "px";
    },
    slateX() {
      return "translate3d(" + -this.imgIndex * this.imgWidth + "px,0,0)";
    },
    transitionConfig() {
      return "all " + this.durationTime + "s";
    }
  },
  methods: {
    
    toRight() {
      if (this.loop) {
        // alert(this.loop)
        this.imgIndex++;
        this.dotsIndex++;
        if (this.dotsIndex == this.imgList.length) this.dotsIndex = 0;
        if (this.imgIndex == this.imgList.length + 1) this.loopFn("right");
      } else {
        this.imgIndex++;
        this.dotsIndex++;
        if (this.imgIndex > this.imgList.length - 1)
          return (this.dotsIndex = this.imgIndex = 0);
      }
    },
    loopFn(type) {
      const dur = this.durationTime;
      this.durationTime = 0;
      this.imgIndex = type == "right" ? 0 : this.imgList.length - 1;
      setTimeout(() => {
        this.$nextTick(function() {
          this.durationTime = dur;
          if (type == "right") this.imgIndex++;
          else this.imgIndex--;
        });
      }, 30);
    },
    toDots(index) {
      this.dotsIndex = this.imgIndex = index;
    },
    autoPlay() {
      if (this.auto) {
        clearInterval(this.autoer);
        this.autoer = setInterval(() => {
          this.toRight();
        }, this.autoTime);
      }
    },
    stopAuto() {
      if (this.auto) return clearInterval(this.autoer);
    }
  },
  created() {
    this.imgIndex = this.dotsIndex = this.initIndex;
    this.durationTime = this.duration;
    if (this.auto) this.autoPlay();
  }
};
</script>
<style>
#swiper {
  position: relative;
  overflow: hidden;
  width: 48%;
  height: 400px;
  border: solid 20px #ccc;
  box-sizing: border-box;
}
.swiper-dots {
  position: absolute;
  bottom: 10px;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
}
.swiper-dots button {
  width: 20px;
  height: 20px;
  background: rgba(127, 124, 124, 0.5);
  display: inline-block;
  margin: 0 10px;
  border-radius: 50%;
  color: #333;
  font-weight: normal;
  border: none;
  outline: none;
  transition: all 0.2s;
  cursor: pointer;
  line-height: 20px;
}
.swiper-dots button:hover,
.swiper-dots button.active {
  background: #2baed7;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/shuffling/carousel.vue